<section
  class="shared-loading-progress"
  [class.shared-loading-progress-compact]="compact"
  aria-live="polite"
  aria-busy="true">
  <app-shared-loading-g [animation]="animation"></app-shared-loading-g>
  <p class="shared-loading-progress-message">{{ displayMessage }}</p>
  @if (presentation?.stepLabels?.length) {
    <div class="shared-loading-progress-track">
      <div class="shared-loading-progress-fill" [style.width.%]="progressPercent"></div>
    </div>
    <ol class="shared-loading-progress-steps">
      @for (label of presentation.stepLabels; track label; let stepIndex = $index) {
        <li
          class="shared-loading-progress-step"
          [class.shared-loading-progress-step-complete]="isStepComplete(stepIndex)"
          [class.shared-loading-progress-step-active]="isStepActive(stepIndex)">
          <span class="shared-loading-progress-step-marker">
            @if (isStepComplete(stepIndex)) {
              ✓
            } @else {
              {{ stepIndex + 1 }}
            }
          </span>
          <span class="shared-loading-progress-step-label">{{ label }}</span>
        </li>
      }
    </ol>
  }
</section>
